import { render } from "./fondocambiante_ingles.vue?vue&type=template&id=1c19a9dc&scoped=true"
import script from "./fondocambiante_ingles.vue?vue&type=script&lang=js"
export * from "./fondocambiante_ingles.vue?vue&type=script&lang=js"

import "./fondocambiante_ingles.vue?vue&type=style&index=0&id=1c19a9dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c19a9dc"]])

export default __exports__